import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import DualAudience from "@/components/landing/DualAudience";
import TrustSafety from "@/components/landing/TrustSafety";
import CoverageMap from "@/components/landing/CoverageMap";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import CTABanner from "@/components/landing/CTABanner";
import MarqueeBand from "@/components/landing/MarqueeBand";
import SplashIntro from "@/components/landing/SplashIntro";
import GuidesDownload from "@/components/landing/GuidesDownload";

export default function Landing() {
    return (
        <div data-testid="landing-page" className="bg-[#F8F9FA] text-ink min-h-screen">
            <SplashIntro />
            <Navbar />
            <main>
                <Hero />
                <HowItWorks />
                <DualAudience />
                <MarqueeBand />
                <TrustSafety />
                <CoverageMap />
                <GuidesDownload />
                <Testimonials />
                <FAQ />
                <CTABanner />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
